import React, { useState } from 'react';
import { GripVertical, Phone, User, MapPin, Download, Trash2, StickyNote, Mail, Send, ChevronDown, ChevronRight, ChevronUp, Building2 } from 'lucide-react';

const DealCard = ({ deal, color, STAGES, dragDeal, handleDragStart, handleTouchStart, handleTouchEnd, setEditDeal, quickMove, onStampEmail, dealNumber, isFirst, isLast, onMoveUp, onMoveDown }) => {
  const stageIdx = STAGES.indexOf(deal.stage);
  const ref = deal.updated_at || deal.created_at;
  const days = ref ? Math.floor((Date.now() - new Date(ref).getTime()) / 86400000) : 0;
  const ageColor = days >= 14 ? '#FF3B30' : days >= 7 ? '#FF8C00' : '#555';

  return (
    <div
      data-testid={`deal-card-${deal.id}`}
      draggable
      onDragStart={() => handleDragStart(deal)}
      onTouchStart={(e) => handleTouchStart(deal, e)}
      onTouchEnd={handleTouchEnd}
      onClick={() => setEditDeal({ ...deal })}
      style={{
        background: dragDeal?.id === deal.id ? '#333' : '#1e1e1e',
        border: dragDeal?.id === deal.id ? `2px solid ${color}` : '2px solid #333',
        borderRadius: '8px', padding: '0.75rem', marginBottom: '0.5rem', cursor: 'grab',
        borderLeft: `4px solid ${color}`, transition: 'all 0.15s',
        opacity: dragDeal?.id === deal.id ? 0.6 : 1,
      }}
      onMouseEnter={(e) => { if (!dragDeal) { e.currentTarget.style.borderColor = color; e.currentTarget.style.background = '#252525'; }}}
      onMouseLeave={(e) => { if (!dragDeal) { e.currentTarget.style.borderColor = '#333'; e.currentTarget.style.background = '#1e1e1e'; }}}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flex: 1, minWidth: 0 }}>
          <span style={{
            fontFamily: "'Bangers', cursive", fontSize: '0.85rem', color: color,
            background: `${color}20`, border: `1.5px solid ${color}50`,
            borderRadius: '4px', padding: '0px 5px', flexShrink: 0,
            minWidth: '22px', textAlign: 'center', lineHeight: '20px',
          }}>{dealNumber}</span>
          <span style={{ fontWeight: 800, fontSize: '0.9rem', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{deal.restaurant_name}</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
          {!isFirst && (
            <button data-testid={`move-up-${deal.id}`} onClick={onMoveUp}
              style={{ width: '18px', height: '14px', borderRadius: '3px', background: 'rgba(255,255,255,0.06)', border: '1px solid #333', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, fontSize: '0.6rem', lineHeight: 1 }}
              onMouseEnter={(e) => { e.currentTarget.style.background = color; e.currentTarget.style.color = '#000'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = '#666'; }}
              title="Move up">
              <ChevronUp size={10} strokeWidth={3} />
            </button>
          )}
          {!isLast && (
            <button data-testid={`move-down-${deal.id}`} onClick={onMoveDown}
              style={{ width: '18px', height: '14px', borderRadius: '3px', background: 'rgba(255,255,255,0.06)', border: '1px solid #333', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, fontSize: '0.6rem', lineHeight: 1 }}
              onMouseEnter={(e) => { e.currentTarget.style.background = color; e.currentTarget.style.color = '#000'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = '#666'; }}
              title="Move down">
              <ChevronDown size={10} strokeWidth={3} />
            </button>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
        {deal.phone && <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem', color: '#aaa' }}><Phone size={12} /> {deal.phone}</div>}
        {deal.contact && <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem', color: '#aaa' }}><User size={12} /> {deal.contact}</div>}
        {deal.email && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem', color: '#aaa' }}>
            <Mail size={12} /> <span style={{ flex: 1 }}>{deal.email}</span>
            <button
              data-testid={`stamp-email-${deal.id}`}
              onClick={(e) => { e.stopPropagation(); onStampEmail(deal); }}
              title={deal.last_emailed ? `Last emailed: ${new Date(deal.last_emailed).toLocaleString()}\nClick to update` : 'Mark as emailed now'}
              style={{
                background: deal.last_emailed ? '#007AFF20' : 'rgba(255,255,255,0.08)',
                border: `1px solid ${deal.last_emailed ? '#007AFF' : '#444'}`,
                borderRadius: '4px', cursor: 'pointer', padding: '2px 4px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#007AFF'; e.currentTarget.style.color = '#fff'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = deal.last_emailed ? '#007AFF20' : 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = deal.last_emailed ? '#007AFF' : '#aaa'; }}
            >
              <Send size={10} style={{ color: 'inherit' }} />
            </button>
          </div>
        )}
        {deal.last_emailed && (
          <div style={{ fontSize: '0.7rem', color: '#007AFF', fontWeight: 600, marginTop: '0.1rem', paddingLeft: '1rem' }}>
            Emailed {new Date(deal.last_emailed).toLocaleDateString()} {new Date(deal.last_emailed).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </div>
        )}
        {(deal.state || deal.street_address || deal.zipcode) && <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem', color: '#aaa' }}><MapPin size={12} /> {[deal.street_address, deal.state, deal.zipcode].filter(Boolean).join(', ')}</div>}
      </div>
      <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontFamily: "'Bangers', cursive", fontSize: '1.1rem', color: '#FFD700', letterSpacing: '0.02em' }}>
          ${(deal.deal_value || 0).toLocaleString()}
        </div>
        <div style={{ display: 'flex', gap: '4px' }} onClick={(e) => e.stopPropagation()}>
          {stageIdx > 0 && (
            <button onClick={() => quickMove(deal, STAGES[stageIdx - 1])}
              style={{ width: '24px', height: '24px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)', border: '1px solid #444', color: '#aaa', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8rem', padding: 0 }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#FFD700'; e.currentTarget.style.color = '#000'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = '#aaa'; }}
              title={`Move to ${STAGES[stageIdx - 1]}`}
            >◀</button>
          )}
          {stageIdx < STAGES.length - 1 && (
            <button onClick={() => quickMove(deal, STAGES[stageIdx + 1])}
              style={{ width: '24px', height: '24px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)', border: '1px solid #444', color: '#aaa', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8rem', padding: 0 }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#FFD700'; e.currentTarget.style.color = '#000'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = '#aaa'; }}
              title={`Move to ${STAGES[stageIdx + 1]}`}
            >▶</button>
          )}
        </div>
      </div>
      {deal.last_called && (
        <div style={{ marginTop: '0.35rem', fontSize: '0.7rem', color: '#666', fontWeight: 600 }}>
          Called {new Date(deal.last_called).toLocaleDateString()} {new Date(deal.last_called).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
      )}
      {deal.notes && (
        <div style={{ marginTop: '0.35rem', fontSize: '0.7rem', color: '#6A0DAD', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.3rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <StickyNote size={10} /> {deal.notes.length > 40 ? deal.notes.slice(0, 40) + '...' : deal.notes}
        </div>
      )}
      {days >= 1 && (
        <div style={{ marginTop: '0.3rem', fontSize: '0.65rem', fontWeight: 700, color: ageColor, display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
          {days >= 7 ? '⏰' : '·'} {days}d in stage
        </div>
      )}
    </div>
  );
};

const FranchiseGroup = ({ name, deals, color, cardProps, STAGES, onMoveGroup, dealNumber, onMoveDealInColumn, stage, stageDeals }) => {
  const [expanded, setExpanded] = useState(false);
  const totalValue = deals.reduce((s, d) => s + (d.deal_value || 0), 0);
  const states = [...new Set(deals.map(d => d.state).filter(Boolean))];
  const stageIdx = STAGES.indexOf(deals[0]?.stage);

  return (
    <div style={{ marginBottom: '0.5rem' }}>
      <div
        data-testid={`franchise-group-${name.replace(/\s/g, '-').toLowerCase()}`}
        onClick={() => setExpanded(prev => !prev)}
        style={{
          background: expanded ? '#1a1a1a' : '#161616',
          border: `2px solid ${color}50`,
          borderLeft: `4px solid ${color}`,
          borderRadius: '8px', padding: '0.6rem 0.75rem', cursor: 'pointer',
          transition: 'all 0.15s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.borderColor = color; e.currentTarget.style.background = '#1e1e1e'; }}
        onMouseLeave={(e) => { e.currentTarget.style.borderColor = `${color}50`; e.currentTarget.style.background = expanded ? '#1a1a1a' : '#161616'; }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flex: 1, minWidth: 0 }}>
            {expanded ? <ChevronDown size={14} color={color} /> : <ChevronRight size={14} color={color} />}
            <span style={{
              fontFamily: "'Bangers', cursive", fontSize: '0.75rem', color: color,
              background: `${color}20`, border: `1.5px solid ${color}50`,
              borderRadius: '4px', padding: '0px 5px', flexShrink: 0,
              minWidth: '22px', textAlign: 'center', lineHeight: '20px',
            }}>{dealNumber}</span>
            <Building2 size={12} color={color} />
            <span style={{ fontWeight: 800, fontSize: '0.85rem', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</span>
          </div>
          <span style={{
            fontSize: '0.7rem', fontWeight: 800, color: '#000', background: color,
            padding: '1px 6px', borderRadius: '4px', flexShrink: 0,
          }}>
            {deals.length}
          </span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.3rem' }}>
          <span style={{ fontFamily: "'Bangers', cursive", fontSize: '0.95rem', color: '#FFD700', letterSpacing: '0.02em' }}>
            ${totalValue.toLocaleString()}
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }} onClick={(e) => e.stopPropagation()}>
            {states.length > 0 && (
              <span style={{ fontSize: '0.65rem', color: '#666', fontWeight: 600, marginRight: '0.25rem' }}>
                {states.join(', ')}
              </span>
            )}
            {stageIdx > 0 && (
              <button
                onClick={() => onMoveGroup(deals, STAGES[stageIdx - 1])}
                style={{ width: '22px', height: '22px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)', border: '1px solid #444', color: '#aaa', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', padding: 0 }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#FFD700'; e.currentTarget.style.color = '#000'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = '#aaa'; }}
                title={`Move all ${deals.length} to ${STAGES[stageIdx - 1]}`}
              >◀</button>
            )}
            {stageIdx < STAGES.length - 1 && (
              <button
                onClick={() => onMoveGroup(deals, STAGES[stageIdx + 1])}
                style={{ width: '22px', height: '22px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)', border: '1px solid #444', color: '#aaa', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', padding: 0 }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#FFD700'; e.currentTarget.style.color = '#000'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = '#aaa'; }}
                title={`Move all ${deals.length} to ${STAGES[stageIdx + 1]}`}
              >▶</button>
            )}
          </div>
        </div>
      </div>
      {expanded && (
        <div style={{ paddingLeft: '0.5rem', borderLeft: `2px solid ${color}30`, marginLeft: '0.5rem', marginTop: '0.25rem' }}>
          {deals.map((deal, i) => {
            const flatIdx = stageDeals ? stageDeals.findIndex(d => d.id === deal.id) : -1;
            return (
              <DealCard key={deal.id} deal={deal} color={color} {...cardProps}
                dealNumber={`${dealNumber}.${i + 1}`}
                isFirst={flatIdx === 0} isLast={stageDeals ? flatIdx === stageDeals.length - 1 : true}
                onMoveUp={() => onMoveDealInColumn && onMoveDealInColumn(deal.id, stage, -1)}
                onMoveDown={() => onMoveDealInColumn && onMoveDealInColumn(deal.id, stage, 1)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export const KanbanBoard = ({
  STAGES, STAGE_COLORS, getStageDeals, getStageTotal, dragDeal,
  handleDragStart, handleDragOver, handleDrop, handleTouchStart, handleTouchEnd,
  quickMove, moveColumn, setEditDeal, setShowStageEdit, setStageEditName, setStageEditColor,
  exportStageCSV, handleDeleteStageDeals, onStampEmail, onMoveGroup, onMoveDealInColumn,
}) => (
  <div data-testid="kanban-board" style={{
    display: 'flex', gap: '0.75rem', padding: '1rem', overflowX: 'auto', minHeight: 'calc(100vh - 70px)',
  }}>
    {STAGES.map(stage => {
      const stageDeals = getStageDeals(stage);
      const stageTotal = getStageTotal(stage);
      const color = STAGE_COLORS[stage];
      return (
        <div
          key={stage}
          data-testid={`stage-${stage.replace(/\s/g, '-').toLowerCase()}`}
          data-stage={stage}
          onDragOver={handleDragOver}
          onDrop={() => handleDrop(stage)}
          style={{
            flex: '0 0 280px',
            background: dragDeal && dragDeal.stage !== stage ? '#1a1a1a' : '#141414',
            borderRadius: '10px',
            border: dragDeal && dragDeal.stage !== stage ? `2px solid ${color}` : `2px solid ${color}30`,
            display: 'flex', flexDirection: 'column',
            maxHeight: 'calc(100vh - 90px)',
            transition: 'border 0.2s, background 0.2s',
          }}
        >
          {/* Stage Header */}
          <div style={{ padding: '0.75rem 1rem', borderBottom: `3px solid ${color}`, background: `${color}15`, borderRadius: '10px 10px 0 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.25rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                {STAGES.indexOf(stage) > 0 && (
                  <button
                    data-testid={`move-col-left-${stage.replace(/\s/g, '-').toLowerCase()}`}
                    onClick={() => moveColumn(stage, -1)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', color: '#555', fontSize: '0.85rem', fontWeight: 800, transition: 'color 0.15s' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = color}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#555'}
                    title="Move column left"
                  >◀</button>
                )}
                <span
                  style={{ fontFamily: "'Bangers', cursive", fontSize: '1.1rem', color, letterSpacing: '0.03em', cursor: 'pointer' }}
                  onClick={() => { setShowStageEdit(stage); setStageEditName(stage); setStageEditColor(color); }}
                  title="Click to edit column"
                >
                  {stage}
                </span>
                {STAGES.indexOf(stage) < STAGES.length - 1 && (
                  <button
                    data-testid={`move-col-right-${stage.replace(/\s/g, '-').toLowerCase()}`}
                    onClick={() => moveColumn(stage, 1)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', color: '#555', fontSize: '0.85rem', fontWeight: 800, transition: 'color 0.15s' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = color}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#555'}
                    title="Move column right"
                  >▶</button>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {stageDeals.length > 0 && (
                  <button
                    data-testid={`export-${stage.replace(/\s/g, '-').toLowerCase()}`}
                    onClick={() => exportStageCSV(stage)}
                    title={`Export ${stage} as CSV`}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', color: '#555', transition: 'color 0.15s' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#22c55e'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#555'}
                  >
                    <Download size={14} />
                  </button>
                )}
                {stageDeals.length > 0 && (
                  <button
                    onClick={() => handleDeleteStageDeals(stage)}
                    title={`Delete all deals in ${stage}`}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', color: '#555', transition: 'color 0.15s' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#FF3B30'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#555'}
                  >
                    <Trash2 size={14} />
                  </button>
                )}
                <span style={{ fontSize: '0.75rem', fontWeight: 800, color: 'rgba(255,255,255,0.5)', background: 'rgba(255,255,255,0.1)', padding: '2px 8px', borderRadius: '4px' }}>
                  {stageDeals.length}
                </span>
              </div>
            </div>
            <div style={{ fontFamily: "'Bangers', cursive", fontSize: '1.25rem', color: '#FFD700', letterSpacing: '0.02em' }}>
              ${stageTotal.toLocaleString()}
            </div>
          </div>

          {/* Cards */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '0.5rem' }}>
            {(() => {
              // Group deals by restaurant name for franchise detection
              const groups = {};
              stageDeals.forEach(deal => {
                const key = (deal.restaurant_name || '').trim().toLowerCase();
                if (!groups[key]) groups[key] = [];
                groups[key].push(deal);
              });
              // Render in order of first appearance, track global index for numbering
              const seen = new Set();
              let dealNum = 0;
              const cardProps = { STAGES, dragDeal, handleDragStart, handleTouchStart, handleTouchEnd, setEditDeal, quickMove, onStampEmail };
              return stageDeals.map((deal, flatIdx) => {
                const key = (deal.restaurant_name || '').trim().toLowerCase();
                if (seen.has(key)) return null;
                seen.add(key);
                const group = groups[key];
                if (group.length === 1) {
                  dealNum++;
                  const num = dealNum;
                  return <DealCard key={deal.id} deal={deal} color={color} {...cardProps}
                    dealNumber={num} isFirst={flatIdx === 0} isLast={flatIdx === stageDeals.length - 1}
                    onMoveUp={() => onMoveDealInColumn(deal.id, stage, -1)}
                    onMoveDown={() => onMoveDealInColumn(deal.id, stage, 1)}
                  />;
                }
                dealNum++;
                return (
                  <FranchiseGroup key={`franchise-${key}`} name={deal.restaurant_name} deals={group} color={color} cardProps={cardProps} STAGES={STAGES} onMoveGroup={onMoveGroup}
                    dealNumber={dealNum} onMoveDealInColumn={onMoveDealInColumn} stage={stage} stageDeals={stageDeals}
                  />
                );
              });
            })()}
          </div>
        </div>
      );
    })}
  </div>
);
